import { User } from './user.entity';

export class UserComment {
  id: number;

  creation_date: Date;

  user_id: number;

  comment: string;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/usercomment.entity.ts